var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 9.16634H10.4167C10.9692 9.16634 11.4991 8.94685 11.8898 8.55615C12.2805 8.16545 12.5 7.63554 12.5 7.08301C12.5 6.53047 12.2805 6.00057 11.8898 5.60987C11.4991 5.21917 10.9692 4.99967 10.4167 4.99967H6.66667V9.16634ZM15 12.9163C15 13.4088 14.903 13.8964 14.7145 14.3514C14.5261 14.8064 14.2499 15.2198 13.9016 15.568C13.5534 15.9162 13.14 16.1924 12.6851 16.3809C12.2301 16.5693 11.7425 16.6663 11.25 16.6663H5V3.33301H10.4167C11.1508 3.33304 11.8688 3.54855 12.4816 3.95282C13.0944 4.35709 13.575 4.93234 13.8639 5.60723C14.1528 6.28212 14.2373 7.02697 14.1068 7.74942C13.9764 8.47186 13.6367 9.14013 13.13 9.67134C13.6989 10.0008 14.1711 10.474 14.4993 11.0435C14.8276 11.6131 15.0002 12.259 15 12.9163ZM6.66667 10.833V14.9997H11.25C11.8025 14.9997 12.3324 14.7802 12.7231 14.3895C13.1138 13.9988 13.3333 13.4689 13.3333 12.9163C13.3333 12.3638 13.1138 11.8339 12.7231 11.4432C12.3324 11.0525 11.8025 10.833 11.25 10.833H6.66667Z",
    fill: "#2C304B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.230621ebc85dbb04d604d0d810fdf3d2.svg";
export { ForwardRef as ReactComponent };